import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { publicHref } from '../seo/linkHref';

/**
 * react-router <Link> that renders prerendered public routes in their 200
 * trailing-slash form (`/about/`, `/blog/x/#faq`), so crawlers following the
 * hydrated DOM never hit Netlify's `/about` → `/about/` 301. App routes pass
 * through unchanged. Public pages import it as `{ SlashLink as Link }`.
 */
export const SlashLink = forwardRef(function SlashLink({ to, ...rest }, ref) {
  const target =
    typeof to === 'string'
      ? publicHref(to)
      : to && typeof to.pathname === 'string'
        ? { ...to, pathname: publicHref(to.pathname) }
        : to;
  return <Link ref={ref} to={target} {...rest} />;
});

export default SlashLink;
